import { useEffect, useState } from "react";
import axios from 'axios';
import { useNavigate, Link, useParams, useSearchParams } from "react-router-dom";
import AlertMessage from "../include/AlertMessage";
var _ = require('lodash');

function EditUser() {
    const [searchParams] = useSearchParams();
    const page = searchParams.get("page") || 1;


    const { id } = useParams();

    const [alert, setAlert] = useState({ type: "", message: "" });

    const [formData, setFormData] = useState({
        role: '',
        name: '',
        email: '',
        country: '',
        ccode: '+1',
        phone: '',
        password: '',
        cpassword: ''
    });

    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const redirectHistory = useNavigate();

    const [isOpen, setIsOpen] = useState(false);
    const [isCountryOpen, setIsCountryOpen] = useState(false);

    const [searchTerm, setSearchTerm] = useState("");

    const [selectedCountry, setSelectedCountry] = useState({
        flag: "🇺🇸",
        name: "United States",
        code: "+1",
    });
    const [selectedCountryName, setSelectedCountryName] = useState({
        flag: "",
        name: "Select Country"
    });
    const token = sessionStorage.getItem('JWT_TOKEN');


    //Roles Arr
    const ROLES = [
        { label: "Admin", value: "admin" },
        { label: "Business", value: "business" },
        { label: "Customer", value: "customer" },
        { label: "Event", value: "event" },
        { label: "Holiday", value: "course" },
        //{ label: "Staff", value: "staff" }
    ];

    //Countries Arr
    const countries = [
        { flag: "🇺🇸", name: "United States", code: "+1" },
        { flag: "🇬🇧", name: "United Kingdom", code: "+44" },
        { flag: "🇦🇺", name: "Australia", code: "+61" },
        { flag: "🇩🇪", name: "Germany", code: "+49" },
        { flag: "🇫🇷", name: "France", code: "+33" },
        { flag: "🇵🇹", name: "Portugal", code: "+351" }
    ];

    const filteredCountries = countries.filter((c) =>
        c.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSelect = (country) => {

        setFormData((prev) => ({
            ...prev,
            ccode: country.code
        }));
        setSelectedCountry(country);
        setIsOpen(false);
    };

    const handleCountrySelect = (country) => {

        setFormData((prev) => ({
            ...prev,
            country: country.name
        }));

        setSelectedCountryName({
            flag: country.flag,
            name: country.name
        });

        setIsCountryOpen(false);
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const fetchData = async () => {

        try {

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/fetchuserdetail/${id}`,
                {
                    headers: {
                        'Authorization': 'Bearer ' + token
                    }
                }
            );

            const resdata = response.data.data;    
            let fullPhone = resdata.phone || '';

            let code = '';
            let mobile = fullPhone;

            // find country by code
            const foundCountry = countries.find((c) =>
                fullPhone.startsWith(c.code)
            );

            if (foundCountry) {

                code = foundCountry.code;

                // remove country code
                mobile = fullPhone.slice(foundCountry.code.length);

                // set selected dropdown
                setSelectedCountry(foundCountry);
            }

            const prefCountry = resdata.prefs?.country || '';

            const foundCountryName = countries.find(
                (c) => c.name === prefCountry
            );

            if (foundCountryName) {

                setSelectedCountryName({
                    flag: foundCountryName.flag,
                    name: foundCountryName.name
                });
            }

            const customdata = {
                role: resdata.labels?.[0] || '',
                name: resdata.name || '',
                email: resdata.email || '',
                country: prefCountry,
                ccode: code,
                phone: mobile,
                password: '',
                cpassword: ''
            };

            setFormData(customdata);

        } catch (error) {

            const apierror = _.get(
                error,
                ['response', 'data', 'error', 'message'],
                "Something went wrong"
            );

            setAlert({
                type: "error",
                message: apierror
            });

        } finally {

            setLoading(false);
        }
    };

    useEffect(() => {

        document.documentElement.className = "";

        fetchData();

    }, [id]);

    const validate = () => {

        const newErrors = {};

        if (!formData.role)
            newErrors.role = "Role is required.";

        if (!formData.name)
            newErrors.name = "Name is required.";

        if (!formData.email)
            newErrors.email = "Email is required.";

        if (!/\S+@\S+\.\S+/.test(formData.email))
            newErrors.email = "Please enter a valid email.";

        if (!formData.ccode)
            newErrors.ccode = "Country Code is required.";

        if (!formData.phone)
            newErrors.phone = "Phone is required.";

        if (!formData.country)
            newErrors.country = "Country is required.";

        // Password validation only for admin/business
        if (formData.role !== "customer") {

            if (formData.password && formData.password.length < 8)
                newErrors.password = "Password must be at least 8 characters.";

            if (
                formData.password &&
                formData.cpassword &&
                formData.password !== formData.cpassword
            ) {
                newErrors.cpassword = "Passwords do not match.";
            }
        }

        return newErrors;
    };

    const handleUpdate = async (e) => {

        e.preventDefault();

        const newErrors = validate();

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {

            try {

                setLoading(true);

                const response = await axios.put(
                    `${process.env.REACT_APP_API_URL}/editcustomer/${id}`,
                    {
                        userId: id,
                        role: formData.role,
                        name: formData.name,
                        country: formData.country,
                        ccode: formData.ccode,
                        phone: formData.phone,
                        password: formData.password
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token
                        }
                    }
                );

                if (response.status === 200 || response.status === 201) {

                    setAlert({
                        type: "success",
                        message: "User updated successfully!"
                    });

                    setTimeout(() => redirectHistory(`/users?page=${page}`), 2500);  // redirect to listing page
                }

            } catch (err) {

                const apierror = _.get(
                    err,
                    ['response', 'data', 'error', 'message'],
                    "Failed to update user. Please try again"
                );

                setAlert({
                    type: "error",
                    message: apierror
                });

            } finally {

                setLoading(false);
            }
        }
    };

    return (
        <section>

            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li>
                            <Link to="/dashboard" className='btn btn-primary'>
                                Dashboard
                            </Link>
                        </li>

                        <li>
                            <Link to="/users" className='btn btn-primary'>
                                Users
                            </Link>
                        </li>

                        <li>Edit</li>
                    </ul>
                </div>
            </div>

            <div className="section main-section">

                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">

                    <div className="card">

                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon">
                                    <i className="mdi mdi-reorder-horizontal"></i>
                                </span>

                                Edit User
                            </p>
                        </header>

                        <div className="card-content">

                            {loading ? (

                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>

                            ) : (

                                <form onSubmit={handleUpdate}>

                                    {alert.message && (
                                        <AlertMessage
                                            type={alert.type}
                                            message={alert.message}
                                            onClose={() =>
                                                setAlert({
                                                    type: "",
                                                    message: ""
                                                })
                                            }
                                        />
                                    )}

                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">

                                        <div className="field">
                                            <label className="label">
                                                Name <span style={{ color: "red" }}>*</span>
                                            </label>

                                            <div className="control">
                                                <input
                                                    className="input"
                                                    type="text"
                                                    placeholder="Name"
                                                    value={formData.name}
                                                    onChange={e =>
                                                        setFormData({
                                                            ...formData,
                                                            name: e.target.value
                                                        })
                                                    }
                                                />
                                            </div>

                                            {errors.name && (
                                                <p className="help" style={{ color: 'red' }}>
                                                    {errors.name}
                                                </p>
                                            )}
                                        </div>

                                        <div className="field">
                                            <label className="label">
                                                Email
                                            </label>

                                            <div className="control">
                                                <input
                                                    className="input bg-gray-100 cursor-not-allowed"
                                                    type="text"
                                                    value={formData.email}
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                    </div>

                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">
                                                Role <span style={{ color: "red" }}>*</span>
                                            </label>

                                            <div className="control">
                                                <div className="select w-full">
                                                    <select
                                                        className="input"
                                                        value={formData.role}
                                                        onChange={(e) =>
                                                            setFormData({
                                                                ...formData,
                                                                role: e.target.value
                                                            })
                                                        }
                                                    >
                                                        <option value="">Select Role</option>

                                                        {ROLES.map((role, index) => (
                                                            <option key={index} value={role.value}>
                                                                {role.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {errors.role && (
                                                <p className="help" style={{ color: "red" }}>
                                                    {errors.role}
                                                </p>
                                            )}
                                        </div>
                                        <div className="field">
                                            <label className="label">Country <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                {/* Button */}
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setIsCountryOpen((prev) => !prev);
                                                        setIsOpen(false);
                                                    }}
                                                    className="flex items-center p-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                >
                                                    <div className="flex items-center gap-2">
                                                        <span>{selectedCountryName.flag}</span>

                                                        <span>
                                                            {selectedCountryName.name || "Select Country"}
                                                        </span>
                                                    </div>
                                                    <svg
                                                        className="w-4 h-4 ml-auto"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth="2"
                                                            d="M19 9l-7 7-7-7"
                                                        ></path>
                                                    </svg>
                                                </button>
                                                {errors.country && <p className="help" style={{ color: 'red' }}>{errors.country}</p>}
                                                {/* Dropdown */}
                                                {isCountryOpen && (
                                                    <div className="absolute z-10 mt-2 w-full bg-white border rounded-md shadow-lg">
                                                        {/* Search box */}
                                                        <input
                                                            id="country"
                                                            type="text"
                                                            value={searchTerm}
                                                            onChange={handleSearch}
                                                            className="w-full p-2 border-b rounded-t-md focus:outline-none"
                                                            placeholder="Search country..."
                                                        />

                                                        {/* Country list */}
                                                        <ul className="max-h-60 overflow-y-auto">
                                                            <li
                                                                key={123}
                                                                onClick={() => handleCountrySelect('')}
                                                                className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
                                                            >

                                                                <span>
                                                                    Select Country
                                                                </span>
                                                            </li>
                                                            {filteredCountries.map((country, idx) => (
                                                                <li
                                                                    key={idx}
                                                                    onClick={() => handleCountrySelect(country)}
                                                                    className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
                                                                >
                                                                    <span className="mr-2">{country.flag}</span>
                                                                    <span>
                                                                        {country.name}
                                                                    </span>
                                                                </li>
                                                            ))}
                                                            {filteredCountries.length === 0 && (
                                                                <li className="p-2 text-gray-500">No results</li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>

                                    {(formData.role !== "customer") && (

                                        <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">

                                            {/* Password */}
                                            <div className="field">
                                                <label className="label">
                                                    Password
                                                </label>

                                                <div className="control">
                                                    <input
                                                        className="input"
                                                        type="password"
                                                        placeholder="Enter Password"
                                                        value={formData.password}
                                                        onChange={(e) =>
                                                            setFormData({
                                                                ...formData,
                                                                password: e.target.value
                                                            })
                                                        }
                                                    />
                                                </div>

                                                {errors.password && (
                                                    <p className="help" style={{ color: "red" }}>
                                                        {errors.password}
                                                    </p>
                                                )}
                                            </div>

                                            {/* Confirm Password */}
                                            <div className="field">
                                                <label className="label">
                                                    Confirm Password
                                                </label>

                                                <div className="control">
                                                    <input
                                                        className="input"
                                                        type="password"
                                                        placeholder="Confirm Password"
                                                        value={formData.cpassword}
                                                        onChange={(e) =>
                                                            setFormData({
                                                                ...formData,
                                                                cpassword: e.target.value
                                                            })
                                                        }
                                                    />
                                                </div>

                                                {errors.cpassword && (
                                                    <p className="help" style={{ color: "red" }}>
                                                        {errors.cpassword}
                                                    </p>
                                                )}
                                            </div>

                                        </div>
                                    )}

                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">
                                                Phone Number <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <div className="flex items-stretch border rounded-md bg-white relative">
                                                {/* Country Code Dropdown */}
                                                <div className="relative min-w-[140px] border-r bg-gray-50">
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            setIsOpen((prev) => !prev);
                                                            setIsCountryOpen(false);
                                                        }}
                                                        className="flex items-center justify-between w-full px-3 py-2 text-sm"
                                                    >
                                                        <div className="flex items-center gap-2">
                                                            <span>{selectedCountry.flag}</span>
                                                            <span>
                                                                {selectedCountry.code === "Country Code"
                                                                    ? "+Code"
                                                                    : selectedCountry.code}
                                                            </span>
                                                        </div>
                                                        <svg
                                                            className="w-4 h-4"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth="2"
                                                                d="M19 9l-7 7-7-7"
                                                            />
                                                        </svg>
                                                    </button>

                                                    {/* Dropdown */}
                                                    {isOpen && (
                                                        <div className="absolute left-0 top-full z-20 mt-1 w-72 bg-white border rounded-md shadow-lg">

                                                            {/* Search */}
                                                            <input
                                                                type="text"
                                                                value={searchTerm}
                                                                onChange={handleSearch}
                                                                placeholder="Search country..."
                                                                className="w-full px-3 py-2 border-b focus:outline-none"
                                                            />

                                                            {/* Country List */}
                                                            <ul className="max-h-60 overflow-y-auto">
                                                                {filteredCountries.map((country, idx) => (
                                                                    <li
                                                                        key={idx}
                                                                        onClick={() => handleSelect(country)}
                                                                        className="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 cursor-pointer"
                                                                    >
                                                                        <span>{country.flag}</span>

                                                                        <span className="text-sm">
                                                                            {country.name} ({country.code})
                                                                        </span>
                                                                    </li>
                                                                ))}

                                                                {filteredCountries.length === 0 && (
                                                                    <li className="px-3 py-2 text-gray-500">
                                                                        No results found
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Phone Input */}
                                                <input
                                                    type="tel"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    placeholder="Enter phone number"
                                                    value={formData.phone}
                                                    onChange={(e) =>
                                                        setFormData({
                                                            ...formData,
                                                            phone: e.target.value
                                                        })
                                                    }
                                                    className="flex-1 px-4 py-2 focus:outline-none"
                                                />
                                            </div>
                                            {/* Errors */}
                                            <div className="mt-1">
                                                {errors.ccode && (
                                                    <p className="help text-red-500">
                                                        {errors.ccode}
                                                    </p>
                                                )}

                                                {errors.phone && (
                                                    <p className="help text-red-500">
                                                        {errors.phone}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex justify-center items-center">

                                        <div className="field grouped">

                                            <div className="control">
                                                <button
                                                    type="submit"
                                                    className="button green"
                                                >
                                                    Update
                                                </button>
                                            </div>

                                        </div>

                                    </div>

                                </form>
                            )}

                        </div>

                    </div>

                </div>

            </div>

        </section>
    );
}

export default EditUser;